// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared @-domain hint dropdown (signup, login, forgot password, etc.) */
.eids-email-wrap {
  position: relative;
  width: 100%;
  flex: 1 1;
  min-width: 0;
}

.eids-email-suggest {
  list-style: none;
  margin: 0;
  padding: 4px 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 20;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
  margin-top: 2px;
}

.eids-email-suggest li {
  padding: 8px 12px;
  font-size: 14px;
  line-height: 1.3;
  cursor: pointer;
  color: #161616;
  white-space: nowrap;
}

.eids-email-suggest li:hover,
.eids-email-suggest li.is-active {
  background: #f3f3f3;
}

body.light_theme .eids-email-suggest {
  background: #fff;
  border-color: #e4e4e4;
}

html[data-theme="dark"] .eids-email-suggest,
body:not(.light_theme) .eids-email-suggest {
  background: #070808;
  border-color: #474d57;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.6);
}

html[data-theme="dark"] .eids-email-suggest li,
body:not(.light_theme) .eids-email-suggest li {
  color: #eaecef;
}

html[data-theme="dark"] .eids-email-suggest li:hover,
html[data-theme="dark"] .eids-email-suggest li.is-active,
body:not(.light_theme) .eids-email-suggest li:hover,
body:not(.light_theme) .eids-email-suggest li.is-active {
  background: #181a20;
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/EmailInputWithDomainSuggest/EmailInputWithDomainSuggest.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,WAAW;EACX,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;AACrB","sourcesContent":["/* Shared @-domain hint dropdown (signup, login, forgot password, etc.) */\n.eids-email-wrap {\n  position: relative;\n  width: 100%;\n  flex: 1;\n  min-width: 0;\n}\n\n.eids-email-suggest {\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 100%;\n  z-index: 20;\n  max-height: 220px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #e4e4e4;\n  border-radius: 8px;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);\n  margin-top: 2px;\n}\n\n.eids-email-suggest li {\n  padding: 8px 12px;\n  font-size: 14px;\n  line-height: 1.3;\n  cursor: pointer;\n  color: #161616;\n  white-space: nowrap;\n}\n\n.eids-email-suggest li:hover,\n.eids-email-suggest li.is-active {\n  background: #f3f3f3;\n}\n\nbody.light_theme .eids-email-suggest {\n  background: #fff;\n  border-color: #e4e4e4;\n}\n\nhtml[data-theme=\"dark\"] .eids-email-suggest,\nbody:not(.light_theme) .eids-email-suggest {\n  background: #070808;\n  border-color: #474d57;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.6);\n}\n\nhtml[data-theme=\"dark\"] .eids-email-suggest li,\nbody:not(.light_theme) .eids-email-suggest li {\n  color: #eaecef;\n}\n\nhtml[data-theme=\"dark\"] .eids-email-suggest li:hover,\nhtml[data-theme=\"dark\"] .eids-email-suggest li.is-active,\nbody:not(.light_theme) .eids-email-suggest li:hover,\nbody:not(.light_theme) .eids-email-suggest li.is-active {\n  background: #181a20;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
